import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ADD_SIGNATURE_DIALOG_CONFIG } from '../contracts-dialog-config';
import { ContractSignatureType } from 'src/app/domain/enums/contract-signature-type.enum';
import { formatDocument } from 'src/app/shared/utils/document-formatter';

@Component({
  selector: 'app-add-signature-dialog',
  templateUrl: './add-signature-dialog.component.html',
  styleUrls: ['./add-signature-dialog.component.sass']
})
export class AddSignatureDialogComponent {
  form: FormGroup;
  config = ADD_SIGNATURE_DIALOG_CONFIG;
  typeCes: TypeCesEnum;

  constructor(
    private dialogRef: MatDialogRef<AddSignatureDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.buildForm();

    // Se não houver exclusões especificadas, usar padrões
    if (!data.excludedTypes) {
      data.excludedTypes = [ContractSignatureType.EMISSOR, ContractSignatureType.CONTRATANTE];
    }

    if (data.signature) {
      // Pré-formatar o documento se estiver editando
      if (data.signature.document) {
        data.signature.document = formatDocument(data.signature.document);
      }
      this.form.patchValue(data.signature);
    }
  }

  private buildForm(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
      email: ['', [Validators.required, Validators.email]],
      document: ['', [Validators.required]], // Validador será aplicado na submissão ou com máscara
      whatsAppNumber: [''],
      type: [this.data.defaultSignatureType || ContractSignatureType.TESTEMUNHA, Validators.required]
    });
  }

  public getFieldConfig(name: string): any {
    return this.config.find((c) => c.name === name);
  }

  submit() {
    if (this.form.valid) {
      const formData = this.form.value;
      console.log('[AddSignatureDialog] Tipo selecionado:', formData.type); // Log para verificar o tipo

      // Limpar e formatar o documento
      const rawDocument = (formData.document || '').replace(/[^\d]/g, '');
      const formattedDocument = formatDocument(rawDocument);

      // Verificar se o documento formatado é válido (simples verificação de tamanho)
      if (!formattedDocument || (rawDocument.length !== 11 && rawDocument.length !== 14)) {
        this.form.get('document')?.setErrors({ invalidFormat: true });
        this.form.get('document')?.markAsTouched();
        console.error('Documento inválido ou não preenchido');
        return;
      }

      const result = {
        name: formData.name,
        email: formData.email,
        document: formattedDocument, // Enviar documento formatado
        documentRaw: rawDocument,    // Enviar documento sem formatação
        whatsAppNumber: formData.whatsAppNumber,
        type: formData.type,
        role: formData.type
      };

      console.log('Enviando dados de assinatura formatados:', result);
      this.dialogRef.close(result);
    } else {
      // Marcar todos os campos como tocados para mostrar validações
      Object.keys(this.form.controls).forEach(key => {
        this.form.get(key)?.markAsTouched();
      });
    }
  }

  close() {
    this.dialogRef.close();
  }
} 